"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Analytics } from "../../../../Analytics/index.js";
import { CompareProductCheckbox } from "../../../CompareProductCheckbox/index.js";
import { useProductTileData } from "../../../../../hooks/useProductTileData/index.js";
import { ProductActions } from "./ProductActions/index.js";
import { cardFooterStyles } from "./styles.js";
const CardFooter = ({
  showActionButton,
  showCompareProduct,
  pdpNavigationUrl,
  pageType
}) => {
  var _a, _b, _c, _d;
  const { translationsConfig, normalizedData, productTitleId } = useProductTileData();
  return /* @__PURE__ */ jsxs(Box, { sx: cardFooterStyles, children: [
    showCompareProduct && /* @__PURE__ */ jsx(Analytics, { analyticData: { doNotTrack: true }, children: /* @__PURE__ */ jsx(Box, { sx: { marginBottom: "12px" }, children: /* @__PURE__ */ jsx(
      CompareProductCheckbox,
      {
        label: (_a = translationsConfig == null ? void 0 : translationsConfig.translations) == null ? void 0 : _a["comparelabel"],
        partNumber: (_b = normalizedData == null ? void 0 : normalizedData.productInfoData) == null ? void 0 : _b.partNumber,
        productImageUrl: (_c = normalizedData == null ? void 0 : normalizedData.productInfoData) == null ? void 0 : _c.productImageUrl,
        productName: (_d = normalizedData == null ? void 0 : normalizedData.productInfoData) == null ? void 0 : _d.productName,
        showCompareProductButton: showCompareProduct && (normalizedData == null ? void 0 : normalizedData.showCompareProductButton),
        isChdiEligible: normalizedData == null ? void 0 : normalizedData.isChdiEligible,
        isFsaEligible: normalizedData == null ? void 0 : normalizedData.isFsaEligible,
        productTitleId
      }
    ) }) }),
    showActionButton && /* @__PURE__ */ jsx(
      ProductActions,
      {
        pageType,
        pdpNavigationUrl
      }
    )
  ] });
};
export {
  CardFooter
};
